import React from "react";
import { Block, Col, Row } from "../Component";

function AdminPageColumn({ children, col = { xs: 12 } }) {
  return (
    <Row className="g-gs">
      <Col {...col}>
        <Block>{children}</Block>
      </Col>
    </Row>
  );
}

export default AdminPageColumn;
